module.exports = __webpack_public_path__ + "img/settings.d9ccf5cb.svg";